import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Victory1";

const Victory1 = () => {
  const projectId = 43;
  const title = "Victory Phase 1";

  const mapConfig = {
    minZoom: 18,
    zoom: 22,
    bounds: [
        [61.62, 18.63],
        [61.6178, 18.6346],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      // Links disabled in original
      viewProjectLink={null}
      fillOfferLink={null}
    />
  );
};

export default Victory1;
